import React from "react";
import { Redirect } from "react-router-dom";
import { TiClipboard, TiDatabase, TiCalendarOutline } from "react-icons/ti";
import { MdExplore } from "react-icons/md";
import Dashboard from "./containers/Dashboard";
import DataPage from "./containers/DataPage";
import ScenarioPage from "./containers/ScenarioPage";
import withSubNavigation from "./containers/withSubNavigation";
import logOutSequence from "./containers/logOutSequence";
import MultiWeekPlanner from "./containers/MultiWeekPlanner";
import SiteChooser from "./containers/SiteChooser";

export const BASE_ROUTE = "/";

const APPLICATION_ROUTES = {
  dashboard: {
    name: 'Dashboard',
    route: '/dashboards',
    path: '/dashboards/:scenario/date/:startDate/range/:range/offset/:offset',
    icon: <MdExplore size={16} />,
    component: withSubNavigation(Dashboard),
  },
  scenarios: {
    name: 'Scenarios',
    route: '/scenarios',
    path: '/scenarios',
    icon: <TiClipboard size={16} />,
    component: ScenarioPage,
  },
  data: {
    name: 'Data',
    route: '/data',
    path: '/data/:scenario/:dataType/date/:startDate/range/7/offset/0',
    icon: <TiDatabase size={16} />,
    component: withSubNavigation(DataPage),
  },
  multiWeek: {
    name: "Event Planning",
    route: "/event-planner",
    path: "/event-planner",
    icon: <TiCalendarOutline size={16} />,
    component: MultiWeekPlanner,
  },
  landing: {
    name: 'Choose Site',
    route: '/sites',
    path: '/sites',
    component: SiteChooser,
  },
  logout: {
    name: 'Log Out',
    path: '/logout',
    component: () => logOutSequence(),
  },
  default: {
    name: 'Base',
    path: '/',
    component: () => <Redirect to="/" />,
  },
  notFound: {
    name: 'Not Found',
    path: '*',
    component: () => <Redirect to={BASE_ROUTE} />,
  },
};

export default Object.values(APPLICATION_ROUTES);

export const NAVBAR_LINKS = [
  APPLICATION_ROUTES.dashboard,
  APPLICATION_ROUTES.scenarios,
  APPLICATION_ROUTES.data,
  APPLICATION_ROUTES.multiWeek,
];

export const USER_PROFILE_MENU = [
  { ...APPLICATION_ROUTES.landing },
  { ...APPLICATION_ROUTES.logout, withDivider: true },
];
